// extracted by mini-css-extract-plugin
module.exports = {"withdraw_modal_form_close_icon":"WithdrawModalForm_withdraw_modal_form_close_icon__vLu37"};